import React, { useState, createContext, useEffect } from "react";
import jwt_decode from "jwt-decode";
import Cognito from "../Amplify";
import { getTokenSensedia } from "../Utils/RefreshToken";
import {
  api,
  // apiNotSensedia,
  setAuthorization,
  // setAuthorizationNotSensedia,
} from "../middlewares";
const Context = createContext();

function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadCPF, setLoadCpf] = useState(true);
  const [userCPF, setUserCPF] = useState("");
  const [tokenSensediaMeuPerfil, setTokenSensediaMeuPerfil] = useState("");
  const [tempPassword, setTempPassword] = useState("");

  const { signIn, changePassword } = Cognito;

  useEffect(() => {
    checkIfToken();
    carregaCPF();
  }, []);

  const carregaCPF = (cpf) => {
    setUserCPF(cpf);
    setLoadCpf(false);
  };

  const checkIfToken = () => {
    const token = localStorage.getItem("token");
    const tempToken = sessionStorage.getItem("token");
    if (token || tempToken) {
      setAuthenticated(true);
    }
    setLoading(false);
  };

  const mudaPassword = async (credentials) => {
    try {
      const changeResult = await changePassword(
        credentials.password,
        credentials.newPassword
      );
      return changeResult;
    } catch (error) {
      return error.code;
    }
  };

  if (loading && loadCPF) {
    return null;
  }

  async function handleLogin(user, password, stayConnected) {
    const userCognito = await signIn(user, password);

    if (
      userCognito.code === "NotAuthorizedException" ||
      userCognito.code === "PasswordResetRequiredException"
    ) {
      return "NotAuthorizedException";
    } else {
      const convertTokens = (userCognito) => ({
        AccessToken: userCognito?.signInUserSession.accessToken.jwtToken,
        IdToken: userCognito?.signInUserSession.idToken.jwtToken,
        RefreshToken: userCognito?.signInUserSession.refreshToken.token,
      });

      const { IdToken } = convertTokens(userCognito);

      let decodedToken = jwt_decode(IdToken);

      // requisição com token cognito para sensedia
      const tokenSensedia = await getTokenSensedia(IdToken);

      if (tokenSensedia === "unable_to_generate_sensedia_code")
        return "unable_to_generate_sensedia_code";

      await setAuthorization(tokenSensedia?.data?.access_token);
      // await setAuthorizationNotSensedia(decodedToken?.jwtToken);

      if ((await verificaImovelUsuario()) == false) {
        await setAuthorization("");
        return false;
      }

      setTokenSensediaMeuPerfil(tokenSensedia?.data?.access_token);

      if (tokenSensedia?.data === undefined) return;

      localStorage.setItem("token", tokenSensedia?.data?.access_token);

      //if user wants to stay connected
      if (stayConnected) {
        localStorage.setItem("qwert", true);
      } else {
        sessionStorage.setItem("qwert", true);
      }

      // localStorage.setItem("idTokenSens", tokenSensedia?.data?.access_token);

      // localStorage.setItem("tempToken", tokenSensedia?.data?.access_token);

      // localStorage.setItem(
      //   "idtoken",
      //   userCognito?.signInUserSession.idToken.jwtToken
      // );

      carregaCPF(decodedToken["custom:CPF"]);

      setAuthenticated(true);

      await syncDatabase();

      return;
    }
  }

  async function handleAcceptCookies(idCookie) {
    try {
      await api.post("AceiteCookie", { contaId: idCookie });
    } catch (error) {
      return error;
    }
  }

  // função a ser chamada quando usuário digitar o cpf e clicar em cadastrar
  async function verificaImovelUsuario() {
    // pesquisa no banco através do CPF, vai retornar o EMAIL
    let resultVerificaImovelUsuario = "";
    try {
      resultVerificaImovelUsuario = await api.get(
        "Home/VerificaExisteImoveisUsuario"
      );

      // resultVerificaImovelUsuario = await apiNotSensedia.get(
      //   "home/verificaexisteimoveisusuario"
      // );

      return resultVerificaImovelUsuario.data;
    } catch (error) {
      return [];
    }
  }

  // // função a ser chamada quando usuário digitar o cpf e clicar em cadastrar
  async function syncDatabase() {
    try {
      await api.put("/Home/ClearCache");
    } catch (error) {
      return [];
    }
  }

  // usuário digita cpf e clica em cadastrar =>
  // pesquisa no banco pelo CPF, se houver o CPF, usuário é cadastrado no COGNITO (se não houver retorna que não existe o CPF digitado)
  // para o front retorna o email e para o usuário é enviado um email com um código de acesso =>
  // com o CPF e EMAIL, é necessário fazer o login do usuário "por trás dos panos" e assim chamar a tela
  // de troca de senha

  // função a ser chamada quando usuário digitar o cpf e clicar em cadastrar
  async function handleFirstAccess(cpf) {
    // pesquisa no banco através do CPF, vai retornar o EMAIL
    let resultadoComEmail = "";
    try {
      resultadoComEmail = await api
        .get("SignUp", {
          params: { cpf },
        })
        .then((response) => {
          setTempPassword(response.data.senha);
          return response.data;
        })
        .catch((error) => {
          return error.response;
        });
      return resultadoComEmail;
    } catch (error) {
      return [];
    } finally {
      carregaCPF(cpf);
    }
  }

  // função a ser chamada para confirmar o signUP, vai ser chamada quando o usuário digitar o código de acesso que vai receber o email
  const confirmSignUPDeleteUser = async (email, code) => {
    try {
      let res = await Cognito.confirmSignUp(email, code);

      if (res != undefined && res.code == "CodeMismatchException") return res;

      const resultSignIn = await Cognito.signIn(email, tempPassword);

      const resultGetTokenSensedia = await getTokenSensedia(
        resultSignIn.signInUserSession.idToken.jwtToken
      );

      setAuthorization(resultGetTokenSensedia.data.access_token);
      localStorage.setItem(
        "tempSensToken",
        resultGetTokenSensedia.data.access_token
      );

      return res;
    } catch (error) {
      return error;
    }
  };

  // função a ser chamada para confirmar o signUP na troca de e-mail com o user já logado, vai ser chamada quando o usuário digitar o código de acesso que vai receber o email
  const confirmSignUTrocaEmail = async (email, code) => {
    return await Cognito.confirmSignUp(email, code);
  };

  const trocaSenhaSignUp = async (email, senha) => {
    await Cognito.signIn(email, senha);
  };

  return (
    <Context.Provider
      value={{
        authenticated,
        setAuthenticated,
        handleLogin,
        handleFirstAccess,
        handleAcceptCookies,
        mudaPassword,
        userCPF,
        trocaSenhaSignUp,
        confirmSignUPDeleteUser,
        tokenSensediaMeuPerfil,
        carregaCPF,
        confirmSignUTrocaEmail,
        tempPassword,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export { AuthProvider, Context };
